export const environment = {
  production: true,
  buildId: '3873604483523711',
  configFile: 'config.json',
};
